import { type FunctionalComponent, h } from '@stencil/core';
import { ProductDropdownBodyContentDocuments } from './product-card-dropdown-body-documents';
import type { TransformedRange } from '../../types/newProductCard.type';
import type { ProductDocumentsData } from '../../../../../../../api/model/response/documents/public/ProductDocuments';
import type { searcherName } from '../uiaas-search-product-dropdown-button/productDetails.types';

export interface ProductDropdownBodyContent {
    documents: Array<ProductDocumentsData> | [];
    ranges: Array<TransformedRange>;
    isVisible: boolean;
    labelProvider: CallableFunction;
    isGridView?: boolean;
}

export const ProductDropdownBodyContent: FunctionalComponent<
    ProductDropdownBodyContent
> = (props) => {
    const { documents, ranges, isVisible, labelProvider, isGridView } = props;
    const isBothSectionsVisible = ranges?.length && documents?.length;
    const isContentVisible = (items) => items?.some(obj => obj.hasOwnProperty('title') && obj.hasOwnProperty('openUrl'));
    const isDocumentsVisible = documents?.length && isContentVisible(documents);
    const isRangesVisible = ranges?.length && isContentVisible(ranges);

    return (
      <div class="product-card-dropdown-content">
        <div class="product-card-dropdown-content-wrapper">
          <section class="product-card-dropdown-content-data">
            {isDocumentsVisible ? documentsPartial((e, f) => labelProvider(e, f), documents, isVisible, 'Documents', Boolean(isBothSectionsVisible), isGridView, isContentVisible(documents)) : ''}
            {isDocumentsVisible && isRangesVisible ? <div class="product-card-dropdown-content-data__divider" /> : ''}
            {isRangesVisible ? documentsPartial((e, f) => labelProvider(e, f), ranges, isVisible, 'Ranges', Boolean(isBothSectionsVisible), isGridView, isContentVisible(ranges)) : ''}
            {!isDocumentsVisible && !isRangesVisible ? (
              <div class="product-card-dropdown-content-data--zero-result">
                {!isGridView ? <p>{labelProvider('products.dropdown.documents-and-ranges', 'Documents & Ranges')}</p> : ''}
                {noResultListTitle(labelProvider)}
              </div>
            ) : (
              ''
            )}
          </section>
        </div>
      </div>
    );
};

const noResultListTitle = (labelProvider: Function): HTMLElement => (
  <span>
    {`${labelProvider('no-results-found-for', 'No results found for')} ${labelProvider('products.dropdown.documents', 'Documents')} & ${labelProvider('products.dropdown.ranges', 'Ranges')}`}
  </span>
);

const titlePartial = (labelProvider: Function, title: searcherName): HTMLElement => (
  <span class={{
    'product-card-dropdown-content__title': true,
    'product-card-dropdown-content__title--ranges': title === 'Ranges'
  }}>
    {labelProvider(`products.dropdown.${title.toLowerCase()}`, title)}
  </span>
);

const documentsPartial = (
  labelProvider: Function,
  documents: Array<ProductDocumentsData> | Array<TransformedRange>,
  isVisible: boolean,
  type: searcherName,
  isBothSectionsVisible: boolean,
  isGridView: boolean,
  isContentVisible: boolean
): HTMLElement => {
    const items = type === 'Documents' ? documents : documents.slice(0, 3);

    if (isContentVisible) return(
      <section class={{
        'product-card-dropdown-content-data__documents--full-width': isGridView || !isBothSectionsVisible,
        'product-card-dropdown-content-data__documents--half-width': isBothSectionsVisible && !isGridView,
        'product-card-dropdown-content-data__documents--half-width--ranges': isBothSectionsVisible && !isGridView && type === 'Ranges'
      }}>
        {items?.length && !isGridView ? titlePartial(labelProvider, type) : ''}
        <ul>
          {items?.length
            ? items?.map((item) => {
                return (
                  <ProductDropdownBodyContentDocuments
                    document={item}
                    isVisible={isVisible}
                    type={type}
                    itemsQuantity={items?.length}
                  />
                );
            })
            : ''}
        </ul>
      </section>
    );
};
